import { UPDATE_IFRAME_PROPERTIES } from '../actionCreators/actionTypes'
import { updateIframeProperties } from '../actionCreators'

export type IIFrameState = { theme: 'default' | 'light' | 'dark'; isIframe: boolean, locale: string }

export const initialState: IIFrameState = {
  theme: 'light', // 默认主题
  isIframe: true,
  locale: '',
}

type IIframeAction = ReturnType<typeof updateIframeProperties>

const iframeReducer = (state = initialState, action: IIframeAction) => {
  switch (action.type) {
    case UPDATE_IFRAME_PROPERTIES:
      return {
        ...state,
        theme: action.payload.theme,
        isIframe: action.payload.isIframe,
        locale: action.payload.locale,
      };
    default:
      return state
  }
};

export default iframeReducer
